import RenderCofabComponent from "~/renderCofabComponent"

const NeuronEquation = ({ children, layer, neuron }) => (
  <Surface transform="translateY(10px)">
    {children}
    <Surface flexFlow="row" marginLeft={5}>
      <Text fontWeight={600}>{layer}</Text>
      <Text fontWeight={600}>:</Text>
      <Text fontWeight={600}>{neuron}</Text>
    </Surface>
  </Surface>
)

const Equation = (
  <Surface flexFlow="row" alignItems="center" marginTop={20} alignSelf="center">
    <Text size={600} marginY={0} marginRight={5}>
      attribution = activation(
    </Text>
    <NeuronEquation layer="3a" neuron={77}>
      <ZoomedImg
        src={neuronFeatureVis("inceptionv1", "mixed3a", 77)}
        size={60}
        padding={20}
      />
    </NeuronEquation>
    <Text size={600} marginLeft={5} marginRight={3}>
      )
    </Text>
    <Text size={600} marginLeft={5} marginRight={3}>
      ⊙ gradient(
    </Text>
    <NeuronEquation layer="3a" neuron={77}>
      <ZoomedImg
        src={neuronFeatureVis("inceptionv1", "mixed3a", 77)}
        size={60}
        padding={20}
      />
    </NeuronEquation>
    <Text size={600} marginRight={10} marginLeft={3} marginY={0}>
      ,
    </Text>
    <NeuronEquation layer="3b" neuron={379}>
      <ZoomedImg
        src={neuronFeatureVis("inceptionv1", "mixed3b", 379)}
        size={60}
        padding={5}
      />
    </NeuronEquation>
    <Text size={600} marginLeft={3} marginY={0}>
      )
    </Text>
  </Surface>
)
class AngleAttribution extends Component {
  render() {
    const {
      data: { images },
    } = this.props

    return (
      <Surface gridColumn="screen" alignItems="center" marginY={40}>
        <Surface flexFlow="row" alignItems="center">
          <Surface width={570}>
            <Text
              size={500}
              width={450}
              alignSelf="center"
              fontWeight={400}
              lineHeight={1.4}
            >
              We use a linear approximation of attribution to see how
              perpindicular angles are used in curves across natural images.
            </Text>
            {Equation}
            <Text
              size={500}
              width={450}
              marginTop={30}
              alignSelf="center"
              fontWeight={400}
              lineHeight={1.4}
            >
              We see that perpindicular lines helpful across many natural
              features like <b>tires</b>, <b>clocks</b>, and <b>logos</b>.
            </Text>
          </Surface>

          <Surface alignItems="center" marginLeft={20}>
            <Surface alignItems="center" flexFlow="row">
              <Surface
                flexFlow="row"
                flexWrap="wrap"
                width={64 * 7 + 2}
                borderRadius={5}
                style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
                overflow="hidden"
              >
                {images.slice(0, 7 * 4).map(image => (
                  <img style={{ margin: 0, padding: 0 }} src={image} />
                ))}
              </Surface>
            </Surface>
            <Text fontStyle="italic" marginTop={5}>
              Dataset examples with maximum attribution from 3a:77 to 3b:379
            </Text>
          </Surface>
        </Surface>
      </Surface>
    )
  }
}

export default () => (
  <RenderCofabComponent
    folder="angle-attribution"
    component={AngleAttribution}
  />
)
